import React, { useState, useEffect } from 'react';
import { AutoComplete, Input } from 'antd';
import HSNData from '../HSN.json';

const HSNSearchDropdown = ({
  value,
  onChange,
  onSelect,
  placeholder,
  style,
  inputClassName,
  ...props
}) => {
  const [options, setOptions] = useState([]);

  // Ensure value is controlled
  const [internalValue, setInternalValue] = useState(value || '');

  useEffect(() => {
    setInternalValue(value || '');
  }, [value]);

  const handleSearch = (searchText) => {
    if (!searchText || searchText.length < 2) {
      setOptions([]);
      return;
    }

    const filtered = HSNData.filter(item => {
      const hsnCode = String(item['HSN/SAC'] || '');
      const hsnDescription = String(item['HSN_Description'] || '');

      return hsnDescription.toLowerCase().includes(searchText.toLowerCase()) ||
        hsnCode.includes(searchText);
    })
      .slice(0, 50) // Limit results
      .map(item => ({
        value: String(item['HSN/SAC']),
        label: (
          <div style={{ display: 'flex', flexDirection: 'column', padding: '4px 0' }}>
            <span style={{ fontWeight: 600 }}>{item['HSN/SAC']}</span>
            <span style={{ fontSize: '11px', color: '#666', whiteSpace: 'normal', lineHeight: '1.2' }}>
              {item['HSN_Description']}
            </span>
          </div>
        ),
        hsnItem: item
      }));

    setOptions(filtered);
  };

  const handleChange = (data) => {
    setInternalValue(data);
    onChange?.(data);
  };

  const handleSelect = (selectedValue, option) => {
    setInternalValue(selectedValue);
    onChange?.(selectedValue);
    onSelect?.(option.hsnItem);
  };

  return (
    <AutoComplete
      value={internalValue}
      options={options}
      onSearch={handleSearch}
      onChange={handleChange}
      onSelect={handleSelect}
      style={{ width: '100%', verticalAlign: 'middle', marginTop: '8px', ...style }}
      popupMatchSelectWidth={400} // Wider dropdown for descriptions
      {...props}
    >
      <Input
        placeholder={placeholder || "Search HSN"}
        className={inputClassName}
        style={{ verticalAlign: 'middle' }}
      />
    </AutoComplete>
  );
};

export default HSNSearchDropdown; 